const musicLinksValidationEN = {
    "add": {
        "release_name": {
            "required": "Release Name is required"
        },
        "ean": {
            "required": "EAN/UPC is required"
        },
        "artist_name": {
            "required": "Artist Name is required"
        },
        "url_part1": {
            "required": "Url Part 1 is required"
        },
        "url_part2": {
            "required": "Url Part 2 is required",
            "length": "Url Part 2 can not be longer than 10 characters",
            "duplicate": "Oops! This url is already associated with another music link. Please try another url.",
            "urlAvailable": "Url is available",
            "urlInvalid": "Url is invalid"
        },
        "amazonmusic_url": {
            "required": "Amazon Music Url is required",
            "invalid": "Please add a valid Amazon Music Url."
        },
        "applemusic_url": {
            "required": "Apple Music Url is required",
            "invalid": "Please add a valid Apple Music Url."
        },
        "beatport_url": {
            "required": "Beatport Url is required",
            "invalid": "Please add a valid Beatport Url."
        },
        "deezer_url": {
            "required": "Deezer Url is required",
            "invalid": "Please add a valid Deezer Url."
        },
        "junodownload_url": {
            "required": "Junodownload Url is required",
            "invalid": "Please add a valid Junodownload Url."
        },
        "soundcloud_url": {
            "required": "Soundcloud Url is required",
            "invalid": "Please add a valid Soundcloud Url."
        },
        "spotify_url": {
            "required": "Spotify Url is required",
            "invalid": "Please add a valid Spotify Url."
        },
        "tidal_url": {
            "required": "Tidal Url is required",
            "invalid": "Please add a valid Tidal Url."
        },
        "traxsource_url": {
            "required": "Traxsource Url is required",
            "invalid": "Please add a valid Traxsource Url."
        },
        "youtube_url": {
            "required": "Youtube Url is required",
            "invalid": "Please add a valid Youtube Url."
        },
        "anghami_url": {
            "required": "Anghami Url is required",
            "invalid": "Please add a valid Url."
        },
        "bandcamp_url": {
            "required": "Bandcamp Url is required",
            "invalid": "Please add a valid Url."
        },
        "boomplay_url": {
            "required": "Boomplay Url is required",
            "invalid": "Please add a valid Url."
        },
        "iheartradio_url": {
            "required": "iHeartRadio Url is required",
            "invalid": "Please add a valid Url."
        },
        "jiosaavn_url": {
            "required": "JioSaavn Url is required",
            "invalid": "Please add a valid Url."
        },
        "sevendigital_url": {
            "required": "7digital Url is required",
            "invalid": "Please add a valid Url."
        },
        "other_url": {
            "invalid": "Please add a valid Url."
        },
        "pvTrackName": {
            "required": "Track Name is required"
        },
        "pvArtistName": {
            "required": "Artist Name is required"
        }
    },
    "update": {
        "release_name": {
            "required": "Release Name is required"
        },
        "ean": {
            "required": "EAN/UPC is required"
        },
        "artist_name": {
            "required": "Artist Name is required"
        },
        "url_part1": {
            "required": "Url Part 1 is required"
        },
        "url_part2": {
            "required": "Url Part 2 is required",
            "length": "Url Part 2 can not be longer than 10 characters",
            "duplicate": "Oops! This url is already associated with another music link. Please try another url.",
            "urlAvailable": "Url is available",
            "urlInvalid": "Url is invalid"
        },
        "amazonmusic_url": {
            "required": "Amazon Music Url is required",
            "invalid": "Please add a valid Amazon Music Url."
        },
        "applemusic_url": {
            "required": "Apple Music Url is required",
            "invalid": "Please add a valid Apple Music Url."
        },
        "beatport_url": {
            "required": "Beatport Url is required",
            "invalid": "Please add a valid Beatport Url."
        },
        "deezer_url": {
            "required": "Deezer Url is required",
            "invalid": "Please add a valid Deezer Url."
        },
        "junodownload_url": {
            "required": "Junodownload Url is required",
            "invalid": "Please add a valid Junodownload Url."
        },
        "soundcloud_url": {
            "required": "Soundcloud Url is required",
            "invalid": "Please add a valid Soundcloud Url."
        },
        "spotify_url": {
            "required": "Spotify Url is required",
            "invalid": "Please add a valid Spotify Url."
        },
        "tidal_url": {
            "required": "Tidal Url is required",
            "invalid": "Please add a valid Tidal Url."
        },
        "traxsource_url": {
            "required": "Traxsource Url is required",
            "invalid": "Please add a valid Traxsource Url."
        },
        "youtube_url": {
            "required": "Youtube Url is required",
            "invalid": "Please add a valid Youtube Url."
        },
        "anghami_url": {
            "required": "Anghami Url is required",
            "invalid": "Please add a valid Url."
        },
        "bandcamp_url": {
            "required": "Bandcamp Url is required",
            "invalid": "Please add a valid Url."
        },
        "boomplay_url": {
            "required": "Boomplay Url is required",
            "invalid": "Please add a valid Url."
        },
        "iheartradio_url": {
            "required": "iHeartRadio Url is required",
            "invalid": "Please add a valid Url."
        },
        "jiosaavn_url": {
            "required": "JioSaavn Url is required",
            "invalid": "Please add a valid Url."
        },
        "sevendigital_url": {
            "required": "7digital Url is required",
            "invalid": "Please add a valid Url."
        },
        "other_url": {
            "invalid": "Please add a valid Url."
        },
        "pvTrackName": {
            "required": "Track Name is required"
        },
        "pvArtistName": {
            "required": "Artist Name is required"
        }
    },
};

export default musicLinksValidationEN;